import { useEffect, useState } from "react";
import { useSearchParams } from "react-router-dom";
import Swal from "sweetalert2";

import ClientNavbar from "../components/ClientNavbar";
import Footer from "../components/Footer";
import api, { API_URL } from "../services/api";

import "../styles/paymentSuccess.css";

function PaymentSuccess() {

  const [searchParams] = useSearchParams();

  const reference = searchParams.get("reference");

  const [loading, setLoading] = useState(true);

  const [payment, setPayment] = useState(null);

  useEffect(() => {

    const verifyPayment = async () => {

      try {

        const response = await api.get(
          `/payments/verify/${reference}`
        );

        setPayment(response.data);

        Swal.fire({
          icon: "success",
          title: "Payment Successful",
          text: "Your payment has been verified successfully."
        });

      } catch (error) {

        console.error(error);

        Swal.fire({
          icon: "error",
          title: "Verification Failed",
          text:
            error.response?.data?.message ||
            "Unable to verify payment."
        });

      } finally {

        setLoading(false);

      }

    };

    if (reference) {

      verifyPayment();

    } else {

      setLoading(false);

    }

  }, [reference]);

  const handleDownload = async () => {

    Swal.fire({
      title: "Preparing Download...",
      text: "Please wait.",
      allowOutsideClick: false,
      didOpen: () => {
        Swal.showLoading();
      }
    });

    try {

      const response = await api.get(
        `/downloads/paid/${payment.download_token}`
      );

      Swal.close();

      await Swal.fire({
        icon: "success",
        title: "Download Ready",
        text: "Your exam download is starting.",
        timer: 1500,
        showConfirmButton: false
      });

      window.open(
        `${API_URL}${response.data.file_url}`,
        "_blank"
      );

    } catch (error) {

      Swal.close();

      console.error(error);

      Swal.fire({
        icon: "error",
        title: "Download Failed",
        text:
          error.response?.data?.message ||
          "Unable to download exam."
      });

    }

  };

  if (loading) {

    return (
      <>
        <ClientNavbar />

        <div className="payment-success">

          <h2>
            Verifying your payment...
          </h2>

        </div>

        <Footer />
      </>
    );

  }

  if (!payment) {

    return (
      <>
        <ClientNavbar />

        <div className="payment-success">

          <h2>
            Payment verification failed.
          </h2>

        </div>

        <Footer />
      </>
    );

  }

  return (

    <>
      <ClientNavbar />

      <div className="payment-success">

        <div className="success-card">

          <div className="success-icon">
            ✅
          </div>

          <h1>
            Payment Successful
          </h1>

          <p>
            Thank you for purchasing your exam.
          </p>

          <button
            onClick={handleDownload}
          >
            Download Exam
          </button>

        </div>

      </div>

      <Footer />

    </>

  );

}

export default PaymentSuccess;